import React from 'react';
import { FormattedDate } from 'react-intl';
import { Room } from 'shared-types/Room';
import { Price } from 'shared-types/Common';
import { useTranslations } from '@lang';
import { DetailTitle } from '../../styled';
import {
  DateContainer,
  OccupancyContainer,
  BasketItemRow,
  BasketItemColumn,
  RoomDetailsContainer,
} from './RoomMetadata.styles';

type RoomMetadataProps = {
  rate: string;
  numberOfAdults: number;
  numberOfChildren: number;
  roomTotalPrice?: Price;
} & Pick<Room, 'checkIn' | 'checkOut'>;

export const RoomMetadata: React.FC<RoomMetadataProps> = ({
  numberOfChildren,
  numberOfAdults,
  checkIn,
  checkOut,
  rate,
}) => {
  const { t } = useTranslations();

  return (
    <>
      <RoomDetailsContainer>
        <BasketItemColumn isGrow>
          <OccupancyContainer>
            <DetailTitle>{t('common.guests')}</DetailTitle>
            {numberOfChildren > 0 && (
              <div>{t('basket.children', { children: numberOfChildren })}</div>
            )}
            <div>{t('basket.adults', { adults: numberOfAdults })}</div>
          </OccupancyContainer>
        </BasketItemColumn>
        <BasketItemColumn isGrow>
          <DateContainer>
            <DetailTitle>{t('common.date')}</DetailTitle>
            <div>
              <FormattedDate value={checkIn} month="short" day="numeric" year="numeric">
                {(checkInDate) => <>{checkInDate}</>}
              </FormattedDate>

              {' - '}

              <FormattedDate value={checkOut} month="short" day="numeric" year="numeric" />
            </div>
          </DateContainer>
        </BasketItemColumn>
      </RoomDetailsContainer>

      <BasketItemRow isMobile>
        <BasketItemColumn isGrow>
          <OccupancyContainer>
            {numberOfChildren > 0 && (
              <div>{t('basket.children', { children: numberOfChildren })}</div>
            )}
            <div>{t('basket.adults', { adults: numberOfAdults })}</div>
          </OccupancyContainer>
        </BasketItemColumn>
      </BasketItemRow>
      <BasketItemRow isMobile>
        <BasketItemColumn isGrow>
          <DateContainer>
            <div>
              <FormattedDate value={checkIn} month="short" day="numeric" year="numeric">
                {(checkInDate) => <>{checkInDate}</>}
              </FormattedDate>

              {' - '}

              <FormattedDate value={checkOut} month="short" day="numeric" year="numeric" />
            </div>
          </DateContainer>
        </BasketItemColumn>
      </BasketItemRow>

      <BasketItemRow>
        <BasketItemColumn isGrow>
          <DetailTitle>{t('common.rate')}</DetailTitle>
          <div>{rate}</div>
        </BasketItemColumn>
      </BasketItemRow>
    </>
  );
};
